/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import * as styled from 'styled-components';

const path = 'https://d11zrgpbhs014a.cloudfront.net/assets/fonts/SBS_Sans_3/';
const path2 = 'https://d11zrgpbhs014a.cloudfront.net/assets/fonts/SBS_Sans_2/';

export default styled.createGlobalStyle`
  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'SBS Sans', Arial, sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSans-Regular.woff2') format('woff2'),
      url('${path}WOFF/SBSSans-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSans-Bold.woff2') format('woff2'),
      url('${path}WOFF/SBSSans-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans Cond';
    src:
      url('${path}WOFF2/SBSSansCond-Bold.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans Cond';
    src:
      url('${path}WOFF2/SBSSansCond-Regular.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans Cond';
    src:
      url('${path}WOFF2/SBSSansCond-Medium.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans Wide 2.0';
    src: url('${path2}WOFF2/SBSSansWide2.0-Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-stretch: expanded;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans Wide 2.0';
    src: url('${path2}WOFF2/SBSSansWide2.0-Medium.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
    font-stretch: expanded;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSansCond-Bold.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src: url('${path}WOFF2/SBSSansCond-Light.woff2') format('woff2');
    font-weight: 100;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path2}WOFF2/SBSSansCond2.0-Extrabold.woff2') format('woff2'),
      url('${path2}WOFF/SBSSansCond2.0-Extrabold.woff') format('woff');
    font-weight: 900;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSansCond-Regular.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSansCond-Medium.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src: url('${path2}WOFF2/SBSSansWide2.0-Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-stretch: expanded;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src: url('${path2}WOFF2/SBSSansWide2.0-Medium.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
    font-stretch: expanded;
    font-display: swap;
  }

  #map-wrap {
    position: relative;
    width: cacl(100% - 4px);
    max-width: 1960px;
    margin: 0 auto;
    height: 600px;
    border: 1px solid #ebeaea;
  }

  @media (max-width: 500px) {
    #map-wrap {
      height: 150vw;
      min-height: 00px;
    }
  }

  .mapContainer {
    width: 100%;
    height: 100%;
  }

  footer {
    width: 100%;
    min-height: 60px;
    font-size: 12px;
  }

  .coal-map-legend {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    width: 100%;
    max-width: 960px;
    margin: 0 auto 10px;
    font-family: 'SBS Sans Cond', 'Arial Narrow', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.25;
  }

  .coal-map-legend__item {
    display: flex;
    align-items: center;
    gap: 7px;
  }

  .coal-map-legend__item img {
    width: 30px;
    height: 30px;
    flex: 0 0 auto;
  }

  .renew-map-legends {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    max-width: 960px;
    margin: 0 auto 12px;
    font-family: 'SBS Sans Cond', 'Arial Narrow', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.25;
  }

  .renew-map-legend {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 7px 18px;
  }

  .renew-map-legend__item {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .renew-map-legend__item img {
    width: 28px;
    height: 28px;
    flex: 0 0 auto;
  }

  .renew-map-legend__status {
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
    border: 2px solid #ffffff;
    border-radius: 50%;
    box-shadow: 0 0 0 1px #777777;
  }

  .renew-popup {
    display: flex;
    flex-direction: column;
    min-width: 180px;
    padding-right: 12px;
    font-family: 'SBS Sans', Arial, sans-serif;
    line-height: 1.35;
  }

  .renew-popup__item {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 3px 0 3px 10px;
    border-left: 4px solid var(--project-color);
  }

  .renew-popup__meta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: 'SBS Sans Cond', 'Arial Narrow', sans-serif;
    font-weight: 500;
  }

  .renew-popup__status-dot {
    width: 8px;
    height: 8px;
    flex: 0 0 auto;
    border-radius: 50%;
    background: var(--project-color);
  }

  .renew-popup strong {
    font-size: 14px;
  }

  .renew-popup span,
  .renew-popup p {
    margin: 0;
    font-size: 12px;
  }

  .renew-popup hr {
    width: 100%;
    margin: 8px 0;
    border: 0;
    border-top: 1px solid #dddddd;
  }

  .coal-popup {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 180px;
    padding: 3px 12px 3px 10px;
    border-left: 4px solid var(--project-color);
    font-family: 'SBS Sans', Arial, sans-serif;
    line-height: 1.35;
  }

  .coal-popup__meta {
    display: flex;
    align-items: center;
    gap: 7px;
    font-family: 'SBS Sans Cond', 'Arial Narrow', sans-serif;
    font-weight: 500;
  }

  .coal-popup__icon {
    width: 28px;
    height: 28px;
    flex: 0 0 auto;
  }

  .coal-popup strong {
    font-size: 14px;
  }

  .coal-popup span,
  .coal-popup p {
    margin: 0;
    font-size: 12px;
  }

  .renew-popup .map-popup__description,
  .coal-popup .map-popup__description {
    margin-top: 4px;
    line-height: 1.4;
  }

  @media (max-width: 500px) {
    .coal-map-legend {
      align-items: flex-start;
      gap: 6px 12px;
      margin-bottom: 8px;
    }

    .coal-map-legend__item {
      width: calc(50% - 6px);
    }

    .coal-map-legend__item img {
      width: 26px;
      height: 26px;
    }

    .renew-map-legends {
      gap: 10px;
      margin-bottom: 8px;
    }

    .renew-map-legend {
      align-items: flex-start;
      gap: 6px 12px;
    }

    .renew-map-legend__item {
      width: calc(50% - 6px);
    }

    .renew-map-legend__item img {
      width: 26px;
      height: 26px;
    }
  }

  .headline {
    font-family: 'SBS Sans Cond', 'Arial Narrow', sans-serif;
    font-size: 24px;
    font-weight: 700;
    border-left: 4px solid #cf1a17;
    padding-left: 16px;
    margin-bottom: 20px;
  }

  /* Reduce motion flag */
  @media (prefers-reduced-motion: reduce) {
    button {
      animation: none;
    }
  }
`;
